import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_TASKS } from "./paths";
import AuthGuard from "../guards/AuthGuard";

const Tasks = lazy(() => import("@pages/tasks"));

const tasksRoutes = [
  {
    path: PATH_TASKS,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Tasks />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
  },
];

export default tasksRoutes;
